import React from 'react'
import MyGraphics from '../../common/MyGraphics/MyGraphics'

const data = [
  {title: 'Test',
    color: 'red',
    isDifferentScale: true,
    data: [{date: new Date(2000, 0, 3), value: 4},
    {date: new Date(2000, 0, 4), value: 2},
    {date: new Date(2000, 0, 5), value: 6},
    {date: new Date(2000, 0, 6), value: 4},
    {date: new Date(2000, 0, 7), value: 45},
    {date: new Date(2000, 0, 8), value: 2},
    {date: new Date(2000, 0, 9), value: 10},
    {date: new Date(2000, 0, 10), value: 30}]
  },
  {title: 'Test2',
    isDifferentScale: false,
    color: 'green',
    data: [{date: new Date(2000, 0, 3), value: 1},
      {date: new Date(2000, 0, 4), value: 2},
      {date: new Date(2000, 0, 5), value: 3},
      {date: new Date(2000, 0, 6), value: 4},
      {date: new Date(2000, 0, 7), value: 5},
      {date: new Date(2000, 0, 8), value: 6},
      {date: new Date(2000, 0, 9), value: 10},
      {date: new Date(2000, 0, 10), value: 20}]
  },
  {title: 'Test3',
    isDifferentScale: true,
    color: 'green',
    data: [{date: new Date(2000, 0, 3), value: 100},
      {date: new Date(2000, 0, 4), value: 200},
      {date: new Date(2000, 0, 5), value: 300},
      {date: new Date(2000, 0, 6), value: 400},
      {date: new Date(2000, 0, 7), value: 500},
      {date: new Date(2000, 0, 8), value: 600},
      {date: new Date(2000, 0, 9), value: 800},
      {date: new Date(2000, 0, 10), value: 200}]
  }
]
const Test = () => {
  const a = 'Ola'
  return <div className='col-xs-12 col-sm-9' style={{height: 400}}>
    <MyGraphics data={data} />
    <div>Ola</div>
    {console.log(measureWidth(a))}
  </div>
}

export function measureWidth (text, font) {
  const f = font || '12px arial'
  let o = window.$('<div></div>')
      .text(text)
      .css({'position': 'absolute', 'float': 'left', 'white-space': 'nowrap', 'visibility': 'hidden', 'font': f})
      .appendTo(window.$('body'))
  let w = o.width()

  o.remove()

  return w
}
export default Test



// WEBPACK FOOTER //
// ./src/components/general/App/Test.js